
<template>
<div>
  <multiselect v-model="mutableSelectedGame" :show-labels="false" placeholder="Spiel auswählen" :options="allgames" :multiple="false"  track-by="id" label="name" :close-on-select="true"></multiselect>
  <b-button class="button is-small is-white" @click="addG">
    <b-icon custom-size="mdi-18px" type="is-black" icon="plus-circle"></b-icon>
    <span style="position: relative;left: 2px;top: -2px;">Neues Spiel anlegen</span>
  </b-button>

  <b-modal :active.sync="createGame" has-modal-card>
     <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
              <p class="modal-card-title">Spiel hinzufügen</p>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column" style="text-align:left;">
            <b-field label="Name">
              <b-input  maxlength="255" v-model="newGame.name"></b-input>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Spielart">
                <b-select style="width:100%" v-model="newGame.category.id" placeholder="Spielart">
                    <option
                        v-for="option in categories"
                        :value="option.id"
                        :key="option.id">
                        {{ option.name }}
                    </option>
                </b-select>
            </b-field>
          </div>
        </div>

        <div class="columns">
          <div class="column" style="text-align:left;">
            <b-field label="Beschreibung">
                <b-input  maxlength="255" type="textarea" v-model="newGame.description"></b-input>
            </b-field>
          </div>
        </div>

        <div class="columns">
          <div class="column" style="text-align:left;">
            <b-field label="Bild">
              <b-input  maxlength="255" v-model="newGame.image"></b-input>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Code">
              <b-input  maxlength="255" v-model="newGame.code"></b-input>
            </b-field>
          </div>
        </div>

        <div class="columns">
          <div class="column" style="text-align:left;">
            <b-field label="smallEditionUrl">
              <b-input  maxlength="255" v-model="newGame.smallEditionUrl"></b-input>
            </b-field>
          </div>
          <div class="column">

          </div>
        </div>


              {{newGame}}
      </section>

      <footer class="modal-card-foot">
              <b-button class="button is-primary" @click="addGame">Übernehmen</b-button>
      </footer>
    </div>
  </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
const axios = require('axios');

    export default {
      props: ['selectedgame'],
      components: {
      	Multiselect
    	},
        data(){
          return {
            allgames: [],
            categories: [],
            createGame: false,
            mutableSelectedGame: this.selectedgame,
            newGame: {
              category: {
                id: 1,
              },
              name: "",
              description: "",
              image: "",
              code: "",
              smallEditionUrl: ""
            }
          }
        },
        watch: {
          selectedgame(val) {
              this.mutableSelectedGame = val;
          },
          mutableSelectedGame(val) {
            console.log("CHANEE");
            this.$emit('input', val);
          }
        },
        mounted() {
          console.log('Component mounted3.');
          console.log(this.mutableSelectedGame);
          //Get Spiele
          //Get-Categories
          this.getCategories();
          this.getGames();

        },
        methods: {
          addG: function() { //Popop öffnen und
            this.createGame = true;
          },
          addGame: function() { //Ajax-Call zum Speichern
            if ((this.newGame.name) && (this.newGame.description) && (this.newGame.category) && (this.newGame.image) && (this.newGame.code) && (this.newGame.smallEditionUrl)){
              console.log(this.newGame);
              this.allgames.push(this.newGame);
              this.mutableSelectedGame = this.newGame;
              this.createGame = false;
            } else {
              console.log("err");
              this.$buefy.dialog.alert({
                            title: 'Fehler',
                            message: 'Bitte alle Felder ausfüllen.',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            iconPack: 'mdi'
                        });
            }
      		},
          getCategories: function() {
            var _this = this;
            axios.get('/api/categories', {
              withCredentials: true,
            })
            .then(function (response) {
              console.log(response.data);
              _this.categories = response.data;
                _this.categories = response.data;
                _this.newGame.category = _this.categories[0];
              //_this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
              //  _this.loading = false;
            })
            .then(function () {
              // always executed
            });
          },
          getGames: function() {
            var _this = this;
            axios.get('/api/games', {
              withCredentials: true,
            })
            .then(function (response) {
              console.log(response.data);
              _this.allgames = response.data;
              //_this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
              //  _this.loading = false;
            })
            .then(function () {
              // always executed
            });
          }
        },
      }

</script>
